import { render } from "./CircleLegend.vue?vue&type=template&id=2dc2133b&scoped=true"
import script from "./CircleLegend.vue?vue&type=script&lang=ts"
export * from "./CircleLegend.vue?vue&type=script&lang=ts"

import "./CircleLegend.vue?vue&type=style&index=0&id=2dc2133b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2dc2133b"

export default script